import api from "../../api/api";


const requestStatusLabel = ['Pending',"Approved","Ignored","Rejected"];

const sendJoinRequest = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("/clinic/team/send-join-request",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const receivedJoinRequest = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.get("/clinic/team/received-join-request",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const updateRequestStatus = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("/clinic/team/update-request-status",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const getSentPendingRequest = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.get("/clinic/team/sent-pending-request",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const getReceivedPendingRequest = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.get("/clinic/team/received-pending-request",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const clinicTeamServices = {
    requestStatusLabel,
    sendJoinRequest,
    receivedJoinRequest,
    updateRequestStatus,

    getSentPendingRequest,
    getReceivedPendingRequest,

    
}
export default clinicTeamServices;